export default "__VITE_ASSET__DS9Lt4Wi__"